module.exports = __webpack_public_path__ + "static/media/favicon.a031bdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/favicon.svg
// module id = 715
// module chunks = 0